function exampleType(key, name) {
    return {
        key: key,
        name: name
    };
}

export default function exampletypes() {
    return {
        webar: exampleType('webar_example', 'WebAR examples'),
        appar: exampleType('appar_example', 'AppAR examples')
    };
}



// WEBPACK FOOTER //
// ./data/services/example-types.js